<template>
    <div v-if="isHaveItem && blobConfig.show_agency" class="agency">
        <div class="agency-header">
            {{lbl.agency}}
        </div>

        <InputRadio
            v-model="formSearch"
            key="input-category"
            ref="radioAgency"
            :setValue="formSearch"
            :inputLbl="lbl.radioCategory"
            :itemList="agencyListValue"
            :isFirstSave="true"
            :isShowErrorLbl="true"
            :errorInfo="errorInfo[0]"
            @input="clickAgency(formSearch)"
        ></InputRadio>

        <div class="btn-show-more">
            <div class="btn-text">
                {{ lbl.showMore }}
                <img src="@/assets/icon/ic-arrow-down-orange.svg" />
            </div>
        </div>
    </div>
</template>

<script>
import Locale from "@/helper/locale/Locale.js";
// service
import BzbsAgency from "@/service/BzbsAgency.js"
// helper
import Account from "@/helper/AccountHelper.js";
import FormHelper from "@/helper/FormHelper.js";
// components
import InputRadio from "../Category/RadioBox.vue";

export default {
    components: {
        InputRadio,
    },
    props: {
        categoryConfig: String,
    },
    data() {
        return {
            lbl: Locale.getLbl().searchList.sidebar,
            isLoaded: false,
            isHaveItem: false,
            agencys: [],
            agencysSplit: [],
            formSearch: null,
            agencyListValue: [],
            selectAgency: {},
            errorInfo: FormHelper.genErrorInfo(1),
        }
    },
    created () {
        this.initialAgency();
        this.blobConfig = Account.getCacheBlob();
    },
    methods: {
        initialAgency: function () {
            var token = Account.getToken();
            BzbsAgency.apiGetAgency(token, this.categoryConfig).then((data) => {
                // console.log(`🚀 ~ file: Agency.vue:62 ~ BzbsAgency.apiGetAgency ~ data:`, data)
                var index = 0;
                for (var agency of data) {
                    index++;
                    this.agencys.push(agency);
                    if (index == 10) {
                        this.agencysSplit.push(this.agencys);
                        this.agencys = [];
                        index = 0;
                    }
                }

                if (this.agencys.length > 0) {
                    this.agencysSplit.push(this.agencys);
                }

                this.isLoaded = true;
                var agencysList = new FormHelper.ItemListValue();
                for(let i = 0; i < this.agencys.length; i++){
                    agencysList.add(
                        this.agencys[i].name,
                        this.agencys[i].id,
                    );
                }
                this.agencyListValue = agencysList.getList();
                this.isHaveItem = this.agencyListValue.length > 0
                    ? true
                    : false;

            }).catch((error) => {
                this.isLoaded = true;
                this.isHaveItem = false;
                console.log(error);
            });
        },
        clickAgency: function (agency) {
            let agencysFilter = this.agencys.filter(e => e.id === agency)
            if(agencysFilter.length === 0) {
                this.selectAgency = this.agencys[0]
            }else{
                this.selectAgency = agencysFilter[0]
            }
            if(agency === null){
                this.selectAgency['id'] = undefined
            }
            this.$emit('changeAgency', this.selectAgency);
        },
        clearValue: function() {
            this.formSearch = null
            this.$refs.radioAgency.clearValue()
        }
    },
}
</script>

<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "./Agency.scss";
</style>
